import { Link } from "react-router-dom";
import { isExternal } from "@/lib/menuLinks";

export default function MenuLink({ url, children, ...rest }) {
  if (isExternal(url)) {
    return <a href={url} target="_blank" rel="noreferrer" {...rest}>{children}</a>;
  }
  return <Link to={url} {...rest}>{children}</Link>;
}
